import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BookingModalService } from './booking-modal.service';
import { Booking } from 'src/app/shared/models/booking/booking';
import { trigger, transition, style } from '@angular/animations';
import { animate } from '@angular/animations';
import { MeService } from 'src/app/shared/api-services/me.service';
import { map } from 'rxjs';
import { PermissionResponse } from 'src/app/shared/models/permission/permission-response';
import * as Permissions from 'src/app/shared/constant/permissions';

export interface BookingModalNewStatus {
  id: number;
  title: string;
  component: any;
}

@Component({
    selector: 'booking-modal',
    templateUrl: './booking-modal.component.html',
    styleUrl: './booking-modal.component.scss',
    animations: [
        trigger('slideAnimation', [
            transition(':enter', [
                style({ transform: 'translateY(100%)' }),
                animate('200ms ease-out', style({ transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ transform: 'translateY(100%)' }))
            ])
        ])
    ],
    standalone: false
})
export class BookingModalComponent {

  @Input() booking: Booking;
  canBookForOthers: boolean = false;

  get currentStep() {
    return this._bookingModalNewService.currentStep;
  }
  
  get bookingModalStatus() {
    return this._bookingModalNewService.bookingModalStatus;
  }

  constructor(
    public bsModalRef: BsModalRef,
    private _bookingModalNewService: BookingModalService,
    private _meService: MeService
  ) { }

  ngOnInit(): void {
    this._bookingModalNewService.onInitModal();
    this.getPermissionCanBookingForOthers();
    if (this.booking) {
      this._bookingModalNewService.setBooking(this.booking);
    }
    this._bookingModalNewService.setBsModalRef(this.bsModalRef);
  }

  getPermissionCanBookingForOthers() {
    this._meService.getMePermissions$()
    .pipe(
      map((permissions: PermissionResponse) => {
        return permissions.items.filter((permission) => permission.name === Permissions.CAN_MANAGE_BOOKINGS);
      })
    )
    .subscribe((permissions) => {
      var countPermissionWithMeId = 0;
      permissions.forEach((permission) => {
        if (permission.expr?.includes('#MEID#')) {
          this._bookingModalNewService.setCanDoBookingForOtherUsers(this.canBookForOthers);
          countPermissionWithMeId++;
        }
      });
      if (countPermissionWithMeId == permissions.length) {
        this.canBookForOthers = false;
      }
      else {
        this.canBookForOthers = true;
      }
      this._bookingModalNewService.setCanDoBookingForOtherUsers(this.canBookForOthers);
    });
  }

  closeModal() {
    this._bookingModalNewService.clearAll();
    this.bsModalRef.hide();
  }
}
